import {Track} from '../shared/classes/Track';

export class Racer{
  key: string;
  name: string;
  surname: string;
  year: number;
  sex: string;
  category: string;
  email: string;
  mobile: string;
  club: string;
  team: string;
  familyTandem: boolean = false;
  voucher: string;
  note: string;
  gdpr: boolean;
  newsletter: boolean;
  raceId: string;
  timeOfReg: Date;
  startFee: any;
  timeOfPay: Date | number;
  paid: boolean;
  pay: any;
  vs: any;
  id: string;
  city: string;
  track: Track | string;
  startNumber: number | any = undefined;
  chipNumber: number | any = undefined;
  lunch: string
}
